// Product categories derived from the title: "macbook" → MacBook, "ipad" → iPad,
// everything else is treated as an iPhone. Shared across catalog pages,
// the homepage featured rows, and the admin featured-order manager.
export const categoryOf = (p) => {
  const name = (p?.name || "").toLowerCase();
  if (name.includes("macbook")) return "macbook";
  if (name.includes("ipad")) return "ipad";
  return "iphone";
};

export const isIpad = (p) => categoryOf(p) === "ipad";
export const isMacbook = (p) => categoryOf(p) === "macbook";
